import axios from '../utils/axios';

export default function getSeekerChangePasswordLink(adminId, params) {
    return axios.get(`/admin/${adminId}/jobseeker-admin/v2/admin-recruiter/changepasswordlink`, { params });
}